import React from "react";
import { allBlogs } from "../../data/allBlogs";
import { Link, useParams } from "react-router-dom";
import "./BlogDetails.css";

const BlogDetails = () => {
  const { id } = useParams();
  const currentBlogId = Number(id); // Convert to number to ensure type consistency

  // Find the selected blog
  const blog = allBlogs.find((item) => item.id === currentBlogId);

  // Get the next three blogs
  const currentIndex = allBlogs.findIndex((item) => item.id === currentBlogId);
  const nextBlogs = allBlogs.slice(currentIndex + 1, currentIndex + 4);

  if (!blog) {
    return <p>Blog not found!</p>;
  }
  return (
    <section className="blog-details page">
      <div className="blog-details-left">
        <div className="info-box">
          <h1>{blog.blogTitle}</h1>
          <p>{blog.blogDate}</p>
        </div>
        <div className="image-box">
          <img src={blog.blogImage} alt={blog.blogTitle} />
        </div>
        <div className="blog-desc">
          <p>{blog.blogDesc}</p>
        </div>
        {blog.firstSection.map((first) => {
          return (
            <div className="section-one">
              <div className="title">
                <h1>{first.title}</h1>
              </div>
              <div className="headlines">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                  >
                    <circle cx="5" cy="5" r="5" fill="#555" />
                  </svg>
                  <p>{first.HeadlineOne}</p>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                  >
                    <circle cx="5" cy="5" r="5" fill="#555" />
                  </svg>
                  <p>{first.HeadlineTwo}</p>
                </div>
              </div>
              <div className="section-one-desc">
                <p>{first.desc}</p>
              </div>
              <div className="image-box">
                <img src={first.firstSectionImg} alt="" />
              </div>
            </div>
          );
        })}
        {blog.seconedSection.map((seconed) => {
          return (
            <div className="section-one">
              <div className="title">
                <h1>{seconed.title}</h1>
              </div>
              <div className="headlines">
                <div>
                  <p>1.</p>
                  <p>{seconed.HeadlineOne}</p>
                </div>
                <div>
                  <p>2.</p>
                  <p>{seconed.HeadlineTwo}</p>
                </div>
                <div>
                  <p>3.</p>
                  <p>{seconed.HeadlineThree}</p>
                </div>
                <div>
                  <p>4.</p>
                  <p>{seconed.HeadlineFour}</p>
                </div>
              </div>
              <div className="image-box">
                <img src={seconed.firstSectionImg} alt="" />
              </div>
            </div>
          );
        })}
        {blog.thirdSection.map((third) => {
          return (
            <div className="section-one">
              <div className="title">
                <h1>{third.title}</h1>
              </div>
              <div className="headlines">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                  >
                    <circle cx="5" cy="5" r="5" fill="#555" />
                  </svg>
                  <p>{third.HeadlineOne}</p>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                  >
                    <circle cx="5" cy="5" r="5" fill="#555" />
                  </svg>{" "}
                  <p>{third.HeadlineTwo}</p>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                  >
                    <circle cx="5" cy="5" r="5" fill="#555" />
                  </svg>{" "}
                  <p>{third.HeadlineThree}</p>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                  >
                    <circle cx="5" cy="5" r="5" fill="#555" />
                  </svg>{" "}
                  <p>{third.HeadlineFour}</p>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                  >
                    <circle cx="5" cy="5" r="5" fill="#555" />
                  </svg>{" "}
                  <p>{third.HeadlineFive}</p>
                </div>
              </div>
              <div className="image-box">
                <img src={third.firstSectionImg} alt="" />
              </div>
            </div>
          );
        })}
        {blog.conclusion.map((conc) => {
          return (
            <div className="conc">
              <h4>{conc.title}</h4>
              <p>{conc.desc}</p>
            </div>
          );
        })}
      </div>
      <div className="blog-details-right">
        <h2>Read Next</h2>
        {nextBlogs.length > 0 ? (
          nextBlogs.map((nextBlog) => (
            <div key={nextBlog.id} className="next-blog">
              <Link to={`/blog/${nextBlog.id}`}>
                <div className="image-box">
                  <img
                    src={nextBlog.blogImage}
                    alt={nextBlog.blogTitle}
                    className="next-blog-image"
                  />
                </div>
                <div className="next-info">
                  <h3>{nextBlog.blogTitle}</h3>
                  <p>{nextBlog.blogDate}</p>
                </div>
              </Link>
            </div>
          ))
        ) : (
          <p>No more blogs to display.</p>
        )}
      </div>
    </section>
  );
};

export default BlogDetails;
